var _style, _ellipse, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReactionSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1500 1500",
    width: 2500,
    height: 2500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#ffda6b}.st1{fill:#262c38}.st2{fill:none;stroke:#262c38;stroke-width:60;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.st3{fill:#6485c3}")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 750.6,
    cy: 745.9,
    rx: 750,
    ry: 745.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M508.2 802.6c0 51.4-42.5 102.3-94.2 102.3s-93.1-50.9-93.1-102.3 42.5-106.7 94.2-106.7c51.8 0 93.1 55.2 93.1 106.7zM1177.8 802.6c0 51.4-42.5 102.3-94.2 102.3s-93.1-50.9-93.1-102.3 42.5-106.7 94.2-106.7 93.1 55.2 93.1 106.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M287.9 647.6s44-106.8 172.4-83.9M1213.9 647.6s-44-106.8-172.4-83.9M571.6 1174s172.4-183.2 356.6 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1287.1 1329s-46.5-145.5-98.7-230.3l-2.8 5c0-.1 0-.1 0 0 0 0-52.9 97.7-98.6 219.1-8.8 23.3-13.3 48.1-11.8 73 2.7 45.7 24.8 104.4 120.4 104.4.1 0 141.4-9 91.5-171.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactionSad);
export default __webpack_public_path__ + "static/media/reaction_sad.c220d0bb933bca902aaf298a70dcccbd.svg";
export { ForwardRef as ReactComponent };